const ChannelClaimedFrom = {
  CHAT: 'CHAT',
  CHECKIN: 'CHECK_IN',
};

export {
  ChannelClaimedFrom,
};
